import { put, takeLatest } from "redux-saga/effects";
import { GetDataMenuAllSuccessAction, IsResultAction, RequertMenuAllFailedAction } from "../actions";
import { GET_DATA_MENU_ALL, SET_DATA_MENU } from "../actions/actionTypes";
import { Api } from "./api";

function* GetDataMenuAll(){
    try{
        const DataMenu = yield Api.GetDataMenuAllFromApi();
        yield put(GetDataMenuAllSuccessAction(DataMenu));
    }
    catch(error){
        yield put(RequertMenuAllFailedAction(error));
    }
}
export function* watchGetDataMenuAll(){
    yield takeLatest(GET_DATA_MENU_ALL, GetDataMenuAll)
}

function* SetDataMenu(action){
    try {
        const isResult = yield Api.SetDataMenuFromApi(action.DataMenu);
        if (isResult) {
            yield put(IsResultAction(isResult))
        }
        else {
            yield put(RequertMenuAllFailedAction("error"))
        }
    } catch (error) {
        yield put(RequertMenuAllFailedAction(error))
    }
}
export function* watchSetDataMenu(){
    yield takeLatest(SET_DATA_MENU,SetDataMenu);
}